// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'הועבר ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'פעולה ' + p['label'] + ' הושלמה',
  accButtonProgressStatus: (p: { label: string }) => 'פעולה ' + p['label'] + ' בתהליך',
  accColorPalette: () => 'לוח צבעים',
  accColorSwatch: () => 'Swatch של צבעים',
  accCommandKey: () => 'פקודה',
  accContextMenuLabel: () => 'פעולות',
  accControlKey: () => 'סגור',
  accPositionAfter: () => 'אחרי',
  accPositionBefore: () => 'לפני',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'הקש והחזק את ' +
    p['keyPressed'] +
    ' ואת מקשי Shift, ולאחר מכן השתמש במקשי החצים כדי לשנות את הסדר.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'הזן תאריך מלא כך: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'הזן חודש ושנה כך: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'תווית',
  chart_labelGroup: () => 'קבוצה',
  chart_labelSeries: () => 'סדרה',
  chart_labelValue: () => 'ערך',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'בחר ערך',
  checkbox_helpForCheckbox: () => 'עזרה לתיבת תיוג',
  checkbox_requiredMessageDetail: () => 'בחר ערך',
  checkbox_selected: () => 'תיבת תיוג מסומנת',
  checkbox_unselected: () => 'תיבת תיוג לא מסומנת',
  close: () => 'סגור',
  collection_apply: () => 'החל',
  collection_cancel: () => 'בטל',
  collection_loaded: () => 'נטען',
  collection_loading: () => 'טוען',
  collection_noData: () => 'אין נתונים להצגה.',
  collection_pixels: () => 'פיקסל',
  collection_resizeColumnDialog: () => 'שנה גודל עמודה',
  collection_resizeColumnMenu: () => 'שנה גודל עמודה...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'הזן מספר בין ' + p['MIN'] + ' לבין ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'בחר את כל השורות',
  collection_selectRow: (p: { ROW_NAME: string }) => 'בחר את שורה ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'סדר עולה',
  collection_sortColumnMenu: () => 'מיין עמודה',
  collection_sortDescendingSubMenu: () => 'סדר יורד',
  collection_sortDisabled: () => 'לא ניתן למיון',
  collection_sortEnabled: () => 'ניתן למיון',
  collection_width: () => 'רוחב',
  colorPicker_label: () => 'בורר צבעים',
  confirmation: () => 'אישור',
  datePicker_currentDate: () => 'תאריך נוכחי',
  datePicker_goToToday: () => 'עבור להיום',
  datePicker_label: () => 'בורר תאריכים',
  datePicker_month: () => 'חודש',
  datePicker_months: () => 'חודשים',
  datePicker_next: () => 'הבא',
  datePicker_nextDecade: () => 'העשור הבא',
  datePicker_nextMonth: () => 'החודש הבא',
  datePicker_prev: () => 'הקודם',
  datePicker_prevDecade: () => 'העשור הקודם',
  datePicker_prevMonth: () => 'החודש הקודם',
  datePicker_restricted: () => 'מוגבל',
  datePicker_selected: () => 'נבחר',
  datePicker_today: () => 'היום',
  datePicker_weekNum: (p: { NUM: string }) => 'שבוע ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'מספר שבוע',
  datePicker_year: () => 'שנה',
  datePicker_years: () => 'שנים',
  diagram_promotedLink: () => 'קישור 1',
  diagram_promotedLinkAriaDesc: () => 'עקיף',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' קישורים',
  error: () => 'שגיאה',
  expandableList_expandCollapseInstructionText: () => 'יש להשתמש במקשי החצים כדי להרחיב ולצמצם',
  expandableList_groupCollapse: () => 'מכווץ',
  expandableList_groupExpand: () => 'מורחב',
  filePicker_addFiles: () => 'הוסף קבצים',
  filePicker_dropzonePrimaryText: () => 'גרור ושחרר',
  filePicker_dropzoneSecondaryText: () => 'בחר קובץ או שחרר אותו כאן',
  filePicker_dropzoneSecondaryTextMultiple: () => 'בחר קבצים או שחרר אותם כאן',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'אי אפשר להעלות קבצים מסוג: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'טען קובץ אחד בכל פעם',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'אי אפשר להעלות קבצים מסוג ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'לא ידוע',
  formControl_clear: () => 'מחק',
  formControl_day: () => 'יום',
  formControl_empty_segment: () => 'ריק',
  formControl_helpAvailable: () => 'עזרה זמינה',
  formControl_hide: () => 'הסתר',
  formControl_hour: () => 'שעה',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'הגעת למגבלה של ' +
    ((
      {
        one: new Intl.NumberFormat('he').format(p['CHARACTER_LIMIT']) + '-תווים',
        two: new Intl.NumberFormat('he').format(p['CHARACTER_LIMIT']) + '-תווים'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('he').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('he').format(p['CHARACTER_LIMIT']) + '-תווים') +
    '.',
  formControl_loading: () => 'טוען',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'אתה יכול להזין עד ' + p['MAX_LENGTH'] + ' תווים.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'חריגה מהאורך המרבי ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' תווים נותרו.',
  formControl_millisecond: () => 'מילישניות',
  formControl_minute: () => 'דקה',
  formControl_month: () => 'חודש',
  formControl_readOnly: () => 'קריאה בלבד',
  formControl_requiredMessageDetail: () => 'הזן ערך.',
  formControl_second: () => 'שנייה',
  formControl_selectionExactMessageDetail: (p: { n: string }) => 'בחר ' + p['n'] + ' ערכים.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'הגעת למגבלה של ' + p['max'] + '-בחירה.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'בחר ערכי ' + p['min'] + ' עד ' + p['max'] + '.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'בחר לפחות ' + p['min'] + ' ערכים.',
  formControl_show: () => 'הצגה',
  formControl_year: () => 'שנה',
  gantt_labelDate: () => 'תאריך',
  gantt_labelEnd: () => 'סיום',
  gantt_labelLabel: () => 'תווית',
  gantt_labelRow: () => 'שורה',
  gantt_labelStart: () => 'התחלה',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. לא נמצא פרק תואם.',
  indexer_keyboardInstructionText: () => 'לחץ על Enter כדי לבחור ערך.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'בין ' + p['FROM_SECTION'] + ' ו-' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'הקש פעמיים והחזק כדי להיכנס למצב מחוות, ולאחר מכן גרור מעלה ומטה כדי להתאים את הערך.',
  info: () => 'מידע',
  inputColor_selectColor: () => 'בחר צבע',
  inputDateMask_date_cleared: () => 'תאריך נמחק',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'ריק',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'הזן תאריך שחל ב-' + p['max'] + ' או לפניו.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'הזן תאריך שחל ב-' + p['min'] + ' או אחריו.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'הזן תאריך זמין.',
  inputDatePicker_instruction: () => 'הקש על Tab כדי לגשת ללוח השנה.',
  inputDatePicker_selectDate: () => 'בחר תאריך',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'הזן חודש ושנה בתאריך ' + p['max'] + ' או לפניו.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'הזן חודש ושנה ב-' + p['min'] + ' או אחריו.',
  inputNumber_converterParseError: () => 'הזן מספר.',
  inputNumber_decrease: () => 'הקטן',
  inputNumber_increase: () => 'הגדל',
  inputPassword_hidden: () => 'סיסמה נסתרת',
  inputPassword_hide: () => 'הסתר סיסמה',
  inputPassword_show: () => 'הצג סיסמה',
  inputSensitiveText_hidden: () => 'טקסט רגיש נסתר',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'הזן שעה שמתחילה ב-' + p['max'] + ' או לפניה.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'הזן שעה שמתחילה ב-' + p['min'] + ' או אחריה.',
  inputTimeMask_time_cleared: () => 'שעת ניקוי',
  labelNone: () => 'ללא',
  list_msgFetchCompleted: () => 'נטען',
  list_msgFetchingData: () => 'טוען',
  list_suggestion: () => 'הצעה',
  menu_stateLoading: () => 'טוען',
  messageToast_allMessagesClosed: () => 'כל ההודעות המוקפצות סגורות.',
  message_close: () => 'סגור',
  message_confirmation: () => 'הצלחה',
  message_error: () => 'שגיאה',
  message_info: () => 'מידע',
  message_navigationFromMessagesRegion: () => 'נכנס לאזור הודעות. הקש על F6 כדי לנווט.',
  message_navigationToMessagesRegion: () => 'אזור ההודעות מכיל הודעות חדשות. לחץ על F6 כדי לנווט',
  message_navigationToTouch: () => 'אזור ההודעות מכיל הודעות חדשות.',
  message_warning: () => 'אזהרה',
  noData_message: () => 'אין פריטים להצגה',
  overflowItemLabel: () => 'כרטיסיות נוספות',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'הקש פעמיים כדי לסגור את החלון הפתוח.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'מזין חלון צץ. לחץ על F6 כדי לנווט בין החלון הצץ והפקד המשויך.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'חלון צץ נפתח. לחץ על F6 כדי לנווט בין החלון הצץ והפקד המשויך.',
  progressIndeterminate: () => 'בתהליך',
  radioButton_checked: () => 'לחצן אפשרויות סומן',
  radioButton_selected: () => 'לחצן אפשרויות  נבחר',
  radioButton_unchecked: () => 'לחצן אפשרויות לא מסומן',
  radioButton_unselected: () => 'לחצן אפשרויות לא נבחר',
  radio_helpForRadio: () => 'עזרה לכפתור רדיו',
  radio_requiredMessageDetail: () => 'בחר ערך',
  selectMultiple_apply: () => 'החל',
  selectMultiple_back: () => 'חזרה',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'השתמש במקשי החצים שמאלה וימינה כדי להדגיש את הערכים שנבחרו.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'הקש על Backspace או Delete כדי להסיר את הערך שנבחר.',
  selectMultiple_selectedValues: () => 'ערכים נבחרים',
  selectMultiple_showSelectedValues: () => 'הצג ערכים בלבד.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) => p['VALUE_COUNT'] + ' ערכים נבחרו.',
  select_addToList: () => 'הוספה לרשימה',
  select_addToListAvailable: () => 'הוספה לרשימה זמינה',
  select_closeDropdown: () => 'הקש על Escape כדי לסגור.',
  select_moreSearchOptions: () => 'אפשרויות חיפוש נוספות',
  select_moreSearchOptionsAvailable: () => 'אפשרויות חיפוש נוספות זמינות',
  select_noMatchesFound: () => 'לא נמצאו התאמות.',
  select_oneMatchFound: () => 'נמצאה התאמה אחת',
  select_requiredMessageDetail: () => 'בחר ערך',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' התאמות נמצאו',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' או יותר התאמות נמצאו',
  selectorAll_deselectAll: () => 'בטל את כל הבחירות',
  selectorAll_selectAll: () => 'בחר הכול',
  selector_selected: () => 'תיבת תיוג מסומנת',
  selector_unselected: () => 'תיבת תיוג לא מסומנת',
  sheet_close: () => 'סגור',
  switch_off: () => 'כבוי',
  switch_on: () => 'פועל',
  tabBarNavigationList_removeCueText: () => 'ניתן להסרה',
  tabBar_tabContainsErrors: () => 'מכיל שגיאות',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' הוסר',
  tabbar_labelContextMenu: () => 'כולל תפריט הקשר',
  tabbar_labelMoveLeft: () => 'העבר שמאלה',
  tabbar_labelMoveRight: () => 'העבר ימינה',
  tabbar_labelRemove: () => 'הסר',
  timeComponent_tooltipZoomIn: () => 'התקרבות',
  timeComponent_tooltipZoomOut: () => 'התרחקות',
  timeConverter_parseError: () => 'הזן שעת השלמה.',
  train_current: () => 'שוטף',
  train_message_type: () => 'סוג הודעה',
  train_not_visited: () => 'לא נרשמו ביקורים',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'שלב ' + p['currentStep'] + ' מתוך ' + p['numberOfSteps'],
  train_visited: () => 'נרשמו ביקורים',
  userAssistance_learnMore: () => 'פרטים נוספים',
  userAssistance_required: () => 'דרוש',
  vis_clearSelection: () => 'נקה בחירה',
  vis_drillable: () => 'ניתן לגלילה',
  vis_invalidData: () => 'נתונים לא תקפים',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' מתוך ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'בחירת ריבוע',
  vis_marqueeZoomTooltip: () => 'זום בריבוע',
  vis_noData: () => 'אין נתונים להצגה',
  vis_panTooltip: () => 'הזזה',
  vis_stateCollapsed: () => 'מכווץ',
  vis_stateExpanded: () => 'מורחב',
  vis_stateLoaded: () => 'נטען',
  vis_stateLoading: () => 'טוען',
  vis_stateSelected: () => 'נבחר',
  vis_stateUnselected: () => 'לא נבחר',
  warn: () => 'אזהרה'
};
export default bundle;
